import { PermissionArrayType } from '../../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../../features/utils/utils.action';
import { OrganizationType } from '../../../../types/organization/organization.type';

export const rmaOrderPermissions: PermissionArrayType = {
  CREATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 'user', 't3_admin', 'support']),
  ],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud'),
    ...getAllPermissionRolesForUserLevel('reseller'),
    ...getAllPermissionRolesForUserLevel('customer'),
  ],
  UPDATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 'user', 't3_admin', 'support']),
  ],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin, PERMISSIONROLECONSTANTS.telcloud_admin],
};

export type SearchOrderFormType = {
  reseller: { id: number; name: string } | null;
  organization: { id: number; name: string } | null;
  location: { id: number; name: string } | null;
  query: string;
};

export const getAllChildren = (
  data: Array<Pick<OrganizationType, 'id' | 'bobo_enabled' | 'level' | 'name' | 'telcobill'> & { parent_id: number }>,
  parentId: number
) => {
  let result: Array<
    Pick<OrganizationType, 'id' | 'bobo_enabled' | 'level' | 'name' | 'telcobill'> & { parent_id: number }
  > = [];

  const children = data.filter(item => item.parent_id === parentId);

  for (const child of children) {
    result.push(child);
    result = result.concat(getAllChildren(data, child.id));
  }

  return result;
};
